//For Firebase Auth
import {
  useFirebase,
  useFirebaseActions,
} from '../services/auth/firebase/FirebaseAuthProvider';
// import { getUserFromFirebase } from './helper/AuthHelper';

export const useAuthUser = () => {
  const { user, isLoading, menuList, isAdminCoofis, isAuthenticated } = useFirebase();
  // const isAuthenticated = true

  return {
    isLoading,
    isAuthenticated,
    user: user,
    menu: menuList,
    isAdminCoofis,
    // user: getUserFromFirebase(user),
  };
};

export const useRoleUser = () => {
  const { setRole } = useFirebaseActions();
  const { currentRole, listRole } = useFirebase();

  return {
    setRole,
    listRole,
    currentRole
  }
}

export const useAuthMethod = () => {
  const {
    logInWithEmailAndPassword,
    registerUserWithEmailAndPassword,
    logInWithPopup,
    loginUser,
    logout,
    logoutEpeg
  } = useFirebaseActions();

  return {
    logInWithEmailAndPassword,
    registerUserWithEmailAndPassword,
    logInWithPopup,
    loginUser,
    logout,
    logoutEpeg,
  };
};